import * as z from 'zod'

function numberWithRange({ fieldName, min, max }: { fieldName: string; min: number; max: number }) {
  return z.preprocess(
    (val) => {
      const num = Number(val)
      return isNaN(num) ? undefined : num
    },
    z
      .number({
        required_error: `${fieldName} must be a valid value`,
        invalid_type_error: `${fieldName} must be a valid number`,
      })
      .min(min, `Must be greater than or equal to ${min}`)
      .max(max, `Must be less than or equal to ${max}`)
  )
}

const baseSchema = z
  .object({
    latitude: numberWithRange({ fieldName: 'Latitude', min: -90, max: 90 }),
    longitude: numberWithRange({ fieldName: 'Longitude', min: -180, max: 180 }),
    radiusValue: z.preprocess(
      (val) => {
        const num = Number(val)
        return isNaN(num) ? undefined : num
      },
      z
        .number({
          required_error: 'Radius is required',
          invalid_type_error: 'Radius must be a valid number',
        })
        .min(0, 'Must be greater than or equal to 0')
    ),
    radiusUnit: z.enum(['feet', 'mile'], {
      required_error: 'Unit is required',
      invalid_type_error: 'Invalid unit',
    }),
  })
  .superRefine((data, ctx) => {
    const { radiusValue, radiusUnit } = data

    if (radiusUnit === 'feet' && radiusValue > 1000) {
      ctx.addIssue({
        path: ['radiusValue'],
        code: z.ZodIssueCode.too_big,
        maximum: 1000,
        type: 'number',
        inclusive: true,
        message: 'Cannot exceed 1000',
      })
    }

    if (radiusUnit === 'mile' && radiusValue > 100) {
      ctx.addIssue({
        path: ['radiusValue'],
        code: z.ZodIssueCode.too_big,
        maximum: 100,
        type: 'number',
        inclusive: true,
        message: 'Cannot exceed 100',
      })
    }
  })

export const locationSchema = {
  schema: baseSchema,
  defaultValues: {
    latitude: '',
    longitude: '',
    radiusValue: 1,
    radiusUnit: 'mile',
  },
}
